import axios from "axios";
const apiURL = process.env.REACT_APP_API_URL;

const BearerToken = () =>
  localStorage.getItem("jwt")
    ? JSON.parse(localStorage.getItem("jwt")).token
    : false;

const Headers = () => {
  return {
    headers: {
      token: `Bearer ${BearerToken()}`,
    },
  };
};

export const getAllOrder = async () => {
  try {
    let res = await axios.get(`${apiURL}/api/order/get-all-orders`, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const editCategory = async (oId, status, loggedInUserId) => {
  let data = { oId: oId, status: status, loggedInUserId: loggedInUserId };
  console.log(data);
  try {
    let res = await axios.post(`${apiURL}/api/order/update-order`, data, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};

export const deleteOrder = async (oId, loggedInUserId) => {
  let data = { oId: oId, loggedInUserId: loggedInUserId };
  try {
    let res = await axios.post(`${apiURL}/api/order/delete-order`, data, Headers());
    return res.data;
  } catch (error) {
    console.log(error);
  }
};
